export default __webpack_public_path__ + "static/media/default-event.e9706c95.png";